import {toast, ToastContent, ToastOptions, Id} from 'react-toastify';

/** Toast notifications. Not state: callable anywhere, also from event handlers. */
export const notify = {
	success(content: ToastContent<unknown>, options?: ToastOptions<{}>): Id {
		return toast.success(content, {draggable: false, ...options});
	},
	info(content: ToastContent<unknown>, options?: ToastOptions<{}>): Id {
		return toast.info(content, {draggable: false, ...options});
	},
	error(content: ToastContent<unknown>, options?: ToastOptions<{}>): Id {
		return toast.error(content, {draggable: false, ...options});
	},
	dismiss(id?: Id): void {
		return toast.dismiss(id);
	},
};

export default () => notify;
